<template>
    <div>
        <div id="down-container" ref="imageWrapper" v-show="!dataURL">
            <div class="down-main">
                <div class="logo-img-box">
                    <img class="logo-img" src="../../../assets/image/logo.png" alt="">
                </div>
                <div class="img-box">
                    <img class="user-img" :src="src+'?'+new Date().getTime()" crossOrigin="anonymous" alt="">
                    <img class="watermark-img" src="../../../assets/image/watermark.png" alt="">
                </div>
                <ul class="down-info">
                    <template v-for="item in userInfo">
                        <li class="down-info-li" :key="item.id" v-if="item.state">
                            <span class="li-title">{{item.name}}:</span><span class="li-text">{{item.value}}</span>
                        </li>
                    </template>
                </ul>
                <ul class="down-desc">
                    <template v-for="item in descInfo">
                        <li class="down-desc-li" :key="item.id" v-if="item.state">
                            <p class="li-title desc-li-title">{{item.name}}</p>
                            <p class="li-text desc-li-text" v-html="strTo(item.value)"></p>
                        </li>
                    </template>
                </ul>
                <div class="bottom-text">YIBAN1314.COM</div>
            </div>
        </div>

        <div id="canvas-box" style="text-align: center;"></div>
        <div style="text-align: center;">
            <el-button type="primary" @click="toImage" v-if="!dataURL">生成图片</el-button>
            <a :href="dataURL" :download="new Date().getTime()" ref="downloadBtn" v-else>
                <el-button type="success">下 载</el-button>
            </a>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas'
    export default {
        props: {
            value: Object
        },
        data() {
            return {
                src: this.value.src,
                userInfo: this.value.userInfo,
                descInfo: this.value.descInfo,
                dataURL: ''
            }
        },
        methods: {
            toImage() {
                var width = this.$refs.imageWrapper.offsetWidth; //dom宽
                var height = this.$refs.imageWrapper.offsetHeight; //dom高
                var scale = 2; //放大倍数
                html2canvas(this.$refs.imageWrapper, {
                    dpi: window.devicePixelRatio * 2,
                    scale: scale,
                    width: width,
                    heigth: height,
                    useCORS: true, // 【重要】开启跨域配置
                }).then((canvas) => {
                    // let box = document.getElementById('canvas-box');
                    // box.appendChild(canvas);
                    // let dataURL = canvas.toDataURL("image/jpg");
                    // this.dataURL = dataURL;

                    let _this = this;
                    canvas.toBlob(function (blob) {
                        // 字符内容转变成blob地址
                        _this.dataURL = URL.createObjectURL(blob);
                        let box = document.getElementById('canvas-box');
                        box.appendChild(canvas);
                    },'image/png',1);
                });
            },

            strTo(str) {
                let regs = new RegExp("\r", "g");
                let reg = new RegExp("\n", "g");
                let regSpace = new RegExp(" ", "g");
                str = str.replace(reg, "<br/>");
                str = str.replace(regs, "<br/>");
                str = str.replace(regSpace, "&nbsp;");
                return str;
            }
        }
    }
</script>

<style scoped>
    li {
        list-style: none;
    }
    ul {
        margin: 0;
        padding: 0;
    }
    #down-container {
        width: 540px;
        margin: 0 auto;
        padding: 65px 36px;
        box-sizing: border-box;
    }

    .down-main {
        border: 1px solid #000;
        padding: 85px 37px 30px;
        box-sizing: border-box;
        position: relative;
    }

    .logo-img-box {
        width: 126px;
        height: 36px;
        position: absolute;
        top: -18px;
        left: 26px;
        background: #fff;
        padding: 0 10px;
    }

    .logo-img {
        width: 126px;
        height: 36px;
    }

    .img-box {
        width: 310px;
        /* height: 412px; */
        position: relative;
        margin: 0 auto;
        z-index: 10;
    }

    .user-img {
        width: 100%;
        display: block;
    }

    .watermark-img {
        width: 85px;
        height: 31px;
        position: absolute;
        right: 16px;
        bottom: 16px;
    }

    .img-box::before {
        content: '';
        width: 50px;
        height: 50px;
        background: #f7ecd9;
        position: absolute;
        top: -16px;
        left: -16px;
        z-index: -1;
    }
    .img-box::after {
        content: '';
        width: 310px;
        height: 100%;
        border: 2px solid #000;
        box-sizing: border-box;
        position: absolute;
        top: 16px;
        left: 16px;
        z-index: -1;
    }

    .down-info {
        margin-top: 83px;
        display: flex;
        flex-wrap: wrap;
        letter-spacing: 1px;
    }
    .down-info::after {
        content: '';
        clear: both;
        display: block;
        height: 0;
        visibility: hidden;
    }
    .down-info-li {
        width: 50%;
        margin-bottom: 11px;
        /* float: left; */
        font-size: 19px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
    }
    .down-info-li:nth-child(2n+1) {
        padding-right: 15px;
    }
    .down-info-li:nth-child(2n+2) {
        padding-left: 15px;
    }
    .li-title {
        font-weight: 600;
        color: #333;
        flex-shrink: 0;
        margin-right: 10px;
    }
    .li-text {
        color: #555;
        flex: 1;
    }

    .down-desc {
        margin-top: 25px;
        letter-spacing: 1px;
    }

    .down-desc-li {
        margin-bottom: 30px;
        font-size: 19px;
        line-height: 36px;
    }

    .desc-li-text {
        text-align: justify;
        word-wrap: break-word;
    }

    .bottom-text {
        width: 130px;
        height: 32px;
        line-height: 32px;
        background: #fff;
        position: absolute;
        right: 26px;
        bottom: -16px;
        text-align: center;
        font-size: 13px;
        color: #333;
        font-family: 'PingFang-SC-Bold';
    }
</style>
